import { render } from "./StudentLife.vue?vue&type=template&id=7ba83461"
import script from "./StudentLife.vue?vue&type=script&lang=js"
export * from "./StudentLife.vue?vue&type=script&lang=js"
script.render = render

export default script